import { Button } from '@journ/ui/button'
import { cn } from '@journ/ui/cn'
import { Icons } from '@journ/ui/icons'

type Props = {
	canScrollLeft: boolean
	canScrollRight: boolean
	onScrollLeft: () => void
	onScrollRight: () => void
	className?: string
}

const HorizontalPagination = ({ canScrollLeft, canScrollRight, onScrollLeft, onScrollRight, className }: Props) => (
	<div className={cn('flex items-center space-x-2', className)}>
		<Button
			variant='outline'
			size='sm'
			disabled={!canScrollLeft}
			className='size-6 p-0'
			onClick={onScrollLeft}
		>
			<Icons.ArrowBack className={cn('size-3.5', canScrollLeft ? 'text-primary' : undefined)} />
		</Button>
		<Button
			variant='outline'
			size='sm'
			disabled={!canScrollRight}
			className='size-6 p-0'
			onClick={onScrollRight}
		>
			<Icons.ArrowForward className={cn('size-3.5', canScrollRight ? 'text-primary' : undefined)} />
		</Button>
	</div>
)

export { HorizontalPagination }
